module.exports = __webpack_public_path__ + "static/media/Graphics_5.4601cf45.png";